
import React, { PropsWithChildren, useMemo } from "react";
import {
    autocompleteClasses,
    createTheme,
    outlinedInputClasses,
    ThemeProvider,
    useTheme
} from "@mui/material";

export function CompatThemeProvider(props: PropsWithChildren): JSX.Element {
    const theme = useTheme();
    const compatTheme = useMemo(() => {
        return createTheme({
            components: {
                MuiInputBase: {
                    styleOverrides: {
                        input: {
                            height: '1.1876em !important',
                            minHeight: '1.1876em !important',
                            [`&.${outlinedInputClasses.input}`]: {
                                paddingTop: '10.5px !important',
                                paddingBottom: '10.5px !important'
                            }
                        }
                    }
                },
                MuiAutocomplete: {
                    styleOverrides: {
                        root: {
                            [`& .${outlinedInputClasses.root} .${autocompleteClasses.input}`]: {
                                padding: '9.5px 4px'
                            }
                        }
                    }
                },
                MuiStepper: {
                    styleOverrides: {
                        root: {
                            justifyContent: 'center'
                        }
                    }
                },
                MuiButton: {
                    defaultProps: {
                        color: "inherit"
                    },
                    styleOverrides: {
                        root: {
                            '&:hover': {
                                backgroundColor: '#d5d5d5'
                            }
                        }
                    }
                }
            },
        }, theme);
    }, [theme]);
    return (
        <ThemeProvider theme={compatTheme}>
            {props.children}
        </ThemeProvider>
    );
}